import PropTypes from "prop-types"
import { Fragment, useState } from "react"
import { Col, Row } from "reactstrap"
import avatar1 from "../../../assets/images/user_without_pic.png"
import {
  getSoftskillsPositionName,
  getSoftskillsProfileName,
  getSoftskillsRegionName,
} from "pages/SoftSkills/Helpers/Helpers"
import EditUserModal from "./EditUserModal"

const SoftskillsProfileBox = ({ user, updateInfo, edit }) => {
  const [showEditModal, setShowEditModal] = useState(undefined)

  return (
    <Fragment>
      <div className="profile-box p-3">
        <Row>
          <Col md={3}>
            <div
              className="mt-2"
              style={{
                position: "relative",
                overflow: "hidden",
                paddingBottom: "100%",
              }}
            >
              <div
                style={{
                  backgroundImage:
                    user.avatar == null
                      ? `url(${avatar1})`
                      : `url(${user.avatar})`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  borderRadius: "50%",
                }}
              >
                &nbsp;
              </div>
            </div>
          </Col>
          <Col md={9}>
            <p className="name mb-1">
              {user.firstName} {user.lastName}
            </p>
            <p className="mb-1">
              <strong>Perfil:</strong>{" "}
              {getSoftskillsProfileName(user.softskillsProfileId)}
            </p>
            <p className="mb-1">
              <strong>Región:</strong>{" "}
              {getSoftskillsRegionName(user.softskillsRegionId)}
            </p>
            <p className="mb-1">
              <strong>Posición:</strong>{" "}
              {getSoftskillsPositionName(user.softskillsPositionId)}
            </p>
            {(edit ?? true) && (
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  onClick={() => setShowEditModal(user)}
                  className="btn btn-primary btn-rounded"
                >
                  <i className="fa fa-edit"></i> Editar
                </button>
              </div>
            )}
          </Col>
        </Row>
      </div>
      {showEditModal !== undefined && (
        <EditUserModal
          onClose={() => setShowEditModal(undefined)}
          onConfirm={() => {
            setShowEditModal(undefined)
            updateInfo()
          }}
          user={showEditModal}
        />
      )}
      <style jsx>{`
        .profile-box {
          border-radius: 12px;
          background-color: rgb(234, 240, 246);
        }
        .profile-box .name {
          font-weight: 500;
          font-size: 20px;
        }
      `}</style>
    </Fragment>
  )
}

SoftskillsProfileBox.propTypes = {
  user: PropTypes.object,
  updateInfo: PropTypes.func,
  edit: PropTypes.bool,
}

export default SoftskillsProfileBox
